var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-between gap-2 mb-2",
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-outline-secondary",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-arrow-left me-1" }),
              _vm._v("\n            Kembali\n        "),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.loadingPage
        ? _c("div", { staticClass: "text-center py-5" }, [
            _c("div", { staticClass: "spinner-border text-primary" }),
            _vm._v(" "),
            _c("div", { staticClass: "mt-2 text-muted" }, [
              _vm._v("Memuat data pasien..."),
            ]),
          ])
        : _vm.errorPage
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c("div", { staticClass: "fw-semibold" }, [
              _vm._v("Data gagal dimuat"),
            ]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.errorPage))]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-outline-danger mt-2",
                attrs: { type: "button" },
                on: { click: _vm.loadPage },
              },
              [
                _c("i", { staticClass: "fa fa-refresh me-1" }),
                _vm._v("\n            Muat Ulang\n        "),
              ]
            ),
          ])
        : [
            _c("div", { staticClass: "card border-0 shadow-sm mb-3" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "card-body patient-card-body" }, [
                _c(
                  "div",
                  { staticClass: "patient-grid" },
                  _vm._l(_vm.patientInfo, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.label,
                        staticClass: "patient-item",
                        class: item.className || "",
                      },
                      [
                        _c("div", { staticClass: "patient-label" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.label) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "patient-value" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.showValue(item.value)) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "patient-status" }, [
                  _c(
                    "span",
                    {
                      staticClass: "badge",
                      class:
                        _vm.pasien.StatusPerawatan === "Masih Dirawat"
                          ? "bg-warning text-dark"
                          : "bg-success",
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.showValue(_vm.pasien.StatusPerawatan)) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row g-3 align-items-stretch workspace-row" },
              [
                _c("div", { staticClass: "col-12 col-xl-4" }, [
                  _c(
                    "div",
                    { staticClass: "card border-0 shadow-sm icd-card" },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _vm.loading.icd
                            ? _c("div", { staticClass: "loading-section" }, [
                                _c("i", {
                                  staticClass: "fa fa-spinner fa-spin me-1",
                                }),
                                _vm._v(
                                  "\n                            Memuat ICD...\n                        "
                                ),
                              ])
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass: "alert alert-info py-2 small",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Baris pertama merupakan diagnosis utama.\n                                Baris berikutnya merupakan diagnosis atau\n                                prosedur sekunder.\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.icdRows, function (row, index) {
                                  return _c(
                                    "div",
                                    { key: row.key, staticClass: "icd-row" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-between gap-2 mb-2",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "badge",
                                              class:
                                                index === 0
                                                  ? "bg-primary"
                                                  : "bg-secondary",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    index === 0
                                                      ? "Diagnosis Utama"
                                                      : `Diagnosis Sekunder ${index}`
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-outline-danger",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.saving,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeIcd(index)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-trash",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "mb-3" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "form-label small fw-semibold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        ICD-10\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-select", {
                                            attrs: {
                                              options: _vm.icd10Options,
                                              filterable: false,
                                              clearable: true,
                                              label: "name",
                                              placeholder:
                                                "Ketik kode atau diagnosis ICD-10...",
                                            },
                                            on: {
                                              search: _vm.searchIcd10,
                                              input: function ($event) {
                                                return _vm.setIcd10(
                                                  $event,
                                                  index
                                                )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-options",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        "\n                                            Ketik minimal satu karakter\n                                        "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: row.diagnosis,
                                              callback: function ($$v) {
                                                _vm.$set(row, "diagnosis", $$v)
                                              },
                                              expression: "row.diagnosis",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "form-label small fw-semibold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        ICD-9\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-select", {
                                            attrs: {
                                              options: _vm.icd9Options,
                                              filterable: false,
                                              clearable: true,
                                              label: "name",
                                              placeholder:
                                                "Ketik kode atau prosedur ICD-9...",
                                            },
                                            on: {
                                              search: _vm.searchIcd9,
                                              input: function ($event) {
                                                return _vm.setIcd9(
                                                  $event,
                                                  index
                                                )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-options",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        "\n                                            Ketik minimal satu karakter\n                                        "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: row.procedure,
                                              callback: function ($$v) {
                                                _vm.$set(row, "procedure", $$v)
                                              },
                                              expression: "row.procedure",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-primary w-100 mt-3",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.saving,
                                    },
                                    on: { click: _vm.addIcd },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-plus-circle me-1",
                                    }),
                                    _vm._v(
                                      "\n                                Tambah Diagnosis\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success w-100 mt-2",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.saving,
                                    },
                                    on: { click: _vm.saveIcd },
                                  },
                                  [
                                    _vm.saving
                                      ? _c("span", {
                                          staticClass:
                                            "spinner-border spinner-border-sm me-1",
                                        })
                                      : _c("i", {
                                          staticClass: "fa fa-save me-1",
                                        }),
                                    _vm._v(
                                      "\n\n                                " +
                                        _vm._s(
                                          _vm.saving
                                            ? "Menyimpan..."
                                            : "Simpan ICD"
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-xl-8" }, [
                  _c(
                    "div",
                    { staticClass: "card border-0 shadow-sm history-card" },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-body p-0 history-scroll" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "accordion history-accordion",
                              attrs: { id: "historyAccordion" },
                            },
                            [
                              _c("div", { staticClass: "accordion-item" }, [
                                _c("h2", { staticClass: "accordion-header" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "accordion-button collapsed",
                                      attrs: {
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#resumeSection",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.loadHistory("resume")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-file-pdf-o text-danger me-2",
                                      }),
                                      _vm._v(
                                        "\n\n                                        Resume Medis Final\n\n                                        "
                                      ),
                                      _vm.resumeAvailable
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge bg-secondary ms-2",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            1\n                                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "accordion-collapse collapse",
                                    attrs: {
                                      id: "resumeSection",
                                      "data-bs-parent": "#historyAccordion",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "accordion-body" },
                                      [
                                        _vm.loading.resume
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "loading-section",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-spinner fa-spin me-1",
                                                }),
                                                _vm._v(
                                                  "\n                                            Memeriksa resume medis...\n                                        "
                                                ),
                                              ]
                                            )
                                          : _vm.resumeAvailable
                                          ? _c("div", [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-danger",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: _vm.openResumePdf,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-file-pdf-o me-1",
                                                  }),
                                                  _vm._v(
                                                    "\n                                                Lihat Resume Medis PDF\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ])
                                          : _c("EmptyState", {
                                              attrs: {
                                                text: "Resume medis final belum tersedia.",
                                              },
                                            }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "accordion-item" }, [
                                _c("h2", { staticClass: "accordion-header" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "accordion-button collapsed",
                                      attrs: {
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#cpptSection",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.loadHistory("cppt")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-stethoscope text-success me-2",
                                      }),
                                      _vm._v(
                                        "\n\n                                        CPPT Periode Rawat\n\n                                        "
                                      ),
                                      _vm.loaded.cppt
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge bg-secondary ms-2",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(_vm.cppt.length) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "accordion-collapse collapse",
                                    attrs: {
                                      id: "cpptSection",
                                      "data-bs-parent": "#historyAccordion",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "accordion-body" },
                                      [
                                        _vm.loading.cppt
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "loading-section",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-spinner fa-spin me-1",
                                                }),
                                                _vm._v(
                                                  "\n                                            Memuat CPPT...\n                                        "
                                                ),
                                              ]
                                            )
                                          : _vm.cppt.length
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "table-responsive",
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table table-bordered table-sm cppt-table mb-0",
                                                  },
                                                  [
                                                    _vm._m(4),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.cppt,
                                                        function (row) {
                                                          return _c(
                                                            "tr",
                                                            {
                                                              key: row.IdCPPT,
                                                              class: {
                                                                "cppt-row-perawat":
                                                                  _vm.isCpptPerawat(
                                                                    row
                                                                  ),
                                                                "cppt-row-dokter":
                                                                  !_vm.isCpptPerawat(
                                                                    row
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c("td", [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      _vm.formatDateTime(
                                                                        row.CreatedAt ||
                                                                          row.UpdatedAt
                                                                      )
                                                                    ) +
                                                                    "\n\n                                                            "
                                                                ),
                                                                row.ApproveCPPT
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "text-success small mt-2",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fa fa-check-circle",
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          "\n                                                                Read back\n                                                                CPPT\n                                                            "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "cppt-soap-cell",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "cppt-soap-content",
                                                                      class: {
                                                                        "cppt-soap-perawat":
                                                                          _vm.isCpptPerawat(
                                                                            row
                                                                          ),
                                                                        "cppt-soap-dokter":
                                                                          !_vm.isCpptPerawat(
                                                                            row
                                                                          ),
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "cppt-soap-line",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "strong",
                                                                            [
                                                                              _vm._v(
                                                                                "S:"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.showValue(
                                                                                    row.Subjective
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "cppt-soap-line",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "strong",
                                                                            [
                                                                              _vm._v(
                                                                                "O:"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.showValue(
                                                                                    row.Objective
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "cppt-soap-line",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "strong",
                                                                            [
                                                                              _vm._v(
                                                                                "A:"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.showValue(
                                                                                    row.Assessment
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "cppt-soap-line",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "strong",
                                                                            [
                                                                              _vm._v(
                                                                                "P:"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.showValue(
                                                                                    row.Planning
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "pre-wrap",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                            " +
                                                                      _vm._s(
                                                                        _vm.showValue(
                                                                          _vm.instruction(
                                                                            row
                                                                          )
                                                                        )
                                                                      ) +
                                                                      "\n                                                        "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("td", [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "fw-semibold",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                                " +
                                                                        _vm._s(
                                                                          _vm.showValue(
                                                                            row.SavedBy
                                                                          )
                                                                        ) +
                                                                        "\n                                                            "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "small text-muted",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                                " +
                                                                        _vm._s(
                                                                          _vm.showValue(
                                                                            row.Dokter
                                                                          )
                                                                        ) +
                                                                        "\n                                                            "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                row.DiisiOleh
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "badge bg-light text-dark border mt-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                " +
                                                                            _vm._s(
                                                                              row.DiisiOleh
                                                                            ) +
                                                                            "\n                                                            "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c("EmptyState", {
                                              attrs: {
                                                text: "Tidak ada CPPT pada registrasi ini.",
                                              },
                                            }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "accordion-item" }, [
                                _c("h2", { staticClass: "accordion-header" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "accordion-button collapsed",
                                      attrs: {
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#labSection",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.loadHistory("lab")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-flask text-primary me-2",
                                      }),
                                      _vm._v(
                                        "\n\n                                        Hasil Laboratorium\n\n                                        "
                                      ),
                                      _vm.loaded.lab
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge bg-secondary ms-2",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(_vm.lab.length) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "accordion-collapse collapse",
                                    attrs: {
                                      id: "labSection",
                                      "data-bs-parent": "#historyAccordion",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "accordion-body" },
                                      [
                                        _vm.loading.lab
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "loading-section",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-spinner fa-spin me-1",
                                                }),
                                                _vm._v(
                                                  "\n                                            Memuat laboratorium...\n                                        "
                                                ),
                                              ]
                                            )
                                          : _vm.lab.length
                                          ? _vm._l(
                                              _vm.lab,
                                              function (row, index) {
                                                return _c(
                                                  "button",
                                                  {
                                                    key: row.Notran || index,
                                                    staticClass: "history-link",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openLab(row)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-flask me-1",
                                                      }),
                                                      _vm._v(
                                                        "\n\n                                                    " +
                                                          _vm._s(
                                                            row.date ||
                                                              _vm.formatDateTime(
                                                                row.Tglhasil ||
                                                                  row.Tanggal
                                                              )
                                                          ) +
                                                          "\n                                                "
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-chevron-right",
                                                    }),
                                                  ]
                                                )
                                              }
                                            )
                                          : _c("EmptyState", {
                                              attrs: {
                                                text: "Tidak ada hasil laboratorium pada registrasi ini.",
                                              },
                                            }),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "accordion-item" }, [
                                _c("h2", { staticClass: "accordion-header" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "accordion-button collapsed",
                                      attrs: {
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#radiologiSection",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.loadHistory("radiologi")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-photo text-primary me-2",
                                      }),
                                      _vm._v(
                                        "\n\n                                        Hasil Radiologi\n\n                                        "
                                      ),
                                      _vm.loaded.radiologi
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge bg-secondary ms-2",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(_vm.radiologi.length) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "accordion-collapse collapse",
                                    attrs: {
                                      id: "radiologiSection",
                                      "data-bs-parent": "#historyAccordion",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "accordion-body" },
                                      [
                                        _vm.loading.radiologi
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "loading-section",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-spinner fa-spin me-1",
                                                }),
                                                _vm._v(
                                                  "\n                                            Memuat radiologi...\n                                        "
                                                ),
                                              ]
                                            )
                                          : _vm.radiologi.length
                                          ? _vm._l(
                                              _vm.radiologi,
                                              function (row, index) {
                                                return _c(
                                                  "button",
                                                  {
                                                    key: `${
                                                      row.NoTran || row.Notran
                                                    }-${index}`,
                                                    staticClass: "history-link",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openRadiologi(
                                                          row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-photo me-1",
                                                      }),
                                                      _vm._v(
                                                        "\n\n                                                    " +
                                                          _vm._s(
                                                            row.date ||
                                                              _vm.formatDateTime(
                                                                row.TglHasil ||
                                                                  row.Tanggal
                                                              )
                                                          ) +
                                                          "\n\n                                                    "
                                                      ),
                                                      row.NmTarif
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-muted",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        -\n                                                        " +
                                                                  _vm._s(
                                                                    row.NmTarif
                                                                  ) +
                                                                  "\n                                                    "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-chevron-right",
                                                    }),
                                                  ]
                                                )
                                              }
                                            )
                                          : _c("EmptyState", {
                                              attrs: {
                                                text: "Tidak ada hasil radiologi pada registrasi ini.",
                                              },
                                            }),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "accordion-item" }, [
                                _c("h2", { staticClass: "accordion-header" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "accordion-button collapsed",
                                      attrs: {
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#medicineSection",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.loadHistory("obat")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-medkit text-primary me-2",
                                      }),
                                      _vm._v(
                                        "\n\n                                        Obat Selama Perawatan\n\n                                        "
                                      ),
                                      _vm.loaded.obat
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge bg-secondary ms-2",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(_vm.obat.length) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "accordion-collapse collapse",
                                    attrs: {
                                      id: "medicineSection",
                                      "data-bs-parent": "#historyAccordion",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "accordion-body" },
                                      [
                                        _vm.loading.obat
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "loading-section",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-spinner fa-spin me-1",
                                                }),
                                                _vm._v(
                                                  "\n                                            Memuat obat...\n                                        "
                                                ),
                                              ]
                                            )
                                          : _vm.obat.length
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "table-responsive",
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table table-bordered table-striped table-sm align-middle mb-0",
                                                  },
                                                  [
                                                    _vm._m(5),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.obat,
                                                        function (row, index) {
                                                          return _c(
                                                            "tr",
                                                            {
                                                              key: `${row.BLCode}-${row.KodeObat}-${index}`,
                                                            },
                                                            [
                                                              _c("td", [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      _vm.formatMedicineDate(
                                                                        row
                                                                      )
                                                                    ) +
                                                                    "\n                                                        "
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("td", [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      _vm.showValue(
                                                                        row.NamaObat
                                                                      )
                                                                    ) +
                                                                    "\n                                                        "
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                            " +
                                                                      _vm._s(
                                                                        _vm.showValue(
                                                                          row.TotalQty ||
                                                                            row.Qty
                                                                        )
                                                                      ) +
                                                                      "\n                                                        "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("td", [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      _vm.showValue(
                                                                        row.Signa
                                                                      )
                                                                    ) +
                                                                    "\n                                                        "
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("td", [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      _vm.showValue(
                                                                        row.NoteCaraMinumObat ||
                                                                          row.NoteSigna
                                                                      )
                                                                    ) +
                                                                    "\n                                                        "
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("td", [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      _vm.showValue(
                                                                        row.NmDoc
                                                                      )
                                                                    ) +
                                                                    "\n                                                        "
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c("EmptyState", {
                                              attrs: {
                                                text: "Tidak ada obat selama perawatan pada registrasi ini.",
                                              },
                                            }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ],
      _vm._v(" "),
      _vm.pdfViewer
        ? _c(
            "div",
            {
              staticClass: "viewer-overlay",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.closeResumePdf.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "viewer-window" }, [
                _c("div", { staticClass: "viewer-toolbar" }, [
                  _c("strong", [_vm._v("Resume Medis Final")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex gap-2" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-sm btn-outline-light",
                        attrs: { href: _vm.resumePdfUrl, target: "_blank" },
                      },
                      [
                        _c("i", { staticClass: "fa fa-external-link me-1" }),
                        _vm._v(
                          "\n                        Buka Tab Baru\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-light",
                        attrs: { type: "button" },
                        on: { click: _vm.closeResumePdf },
                      },
                      [
                        _c("i", { staticClass: "fa fa-times me-1" }),
                        _vm._v(
                          "\n                        Tutup\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("iframe", {
                  staticClass: "pdf-frame",
                  attrs: { src: _vm.resumePdfUrl, title: "Resume Medis Final" },
                }),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.detailViewer
        ? _c(
            "div",
            {
              staticClass: "viewer-overlay",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.closeDetailViewer.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "viewer-window" }, [
                _c("div", { staticClass: "viewer-toolbar" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.detailViewer.title))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-outline-light",
                      attrs: { type: "button" },
                      on: { click: _vm.closeDetailViewer },
                    },
                    [
                      _c("i", { staticClass: "fa fa-times me-1" }),
                      _vm._v("\n                    Tutup\n                "),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "viewer-content" },
                  [
                    _vm.detailViewer.loading
                      ? _c("div", { staticClass: "text-center py-5" }, [
                          _c("div", {
                            staticClass: "spinner-border text-success",
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-2 text-muted" }, [
                            _vm._v("Memuat detail..."),
                          ]),
                        ])
                      : _vm.detailViewer.type === "lab"
                      ? [
                          _c("div", { staticClass: "row g-3 mb-3" }, [
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "text-muted small" }, [
                                _vm._v(
                                  "\n                                No. Laboratorium\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fw-semibold" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.showValue(
                                        _vm.detailViewer.head.Nolab ||
                                          _vm.detailViewer.head.Notran
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "text-muted small" }, [
                                _vm._v(
                                  "\n                                Tanggal Hasil\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fw-semibold" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.formatDateTime(
                                        _vm.detailViewer.head.Tglhasil
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "text-muted small" }, [
                                _vm._v(
                                  "\n                                Dokter Pengirim\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fw-semibold" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.showValue(_vm.detailViewer.head.NmDoc)
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.detailViewer.groups,
                            function (group, groupName) {
                              return _c(
                                "div",
                                { key: groupName, staticClass: "mb-4" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fw-bold text-success border-bottom pb-2 mb-2",
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(groupName) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "table-responsive" },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered table-sm align-middle",
                                        },
                                        [
                                          _vm._m(6, true),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            [
                                              _vm._l(
                                                group,
                                                function (item, code) {
                                                  return [
                                                    _c(
                                                      "tr",
                                                      { key: `head-${code}` },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "fw-semibold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(
                                                                  _vm.showValue(
                                                                    item.head
                                                                      .NMDetail
                                                                  )
                                                                ) +
                                                                "\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            class: {
                                                              "text-danger fw-bold":
                                                                _vm.isCriticalLab(
                                                                  item.head
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(
                                                                  _vm.showValue(
                                                                    item.head
                                                                      .Hasil
                                                                  )
                                                                ) +
                                                                "\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                                                " +
                                                              _vm._s(
                                                                _vm.showValue(
                                                                  item.head
                                                                    .Satuan
                                                                )
                                                              ) +
                                                              "\n                                            "
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                                                " +
                                                              _vm._s(
                                                                _vm.normalValue(
                                                                  item.head
                                                                )
                                                              ) +
                                                              "\n                                            "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      item.detail || [],
                                                      function (detail) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key: `detail-${detail.KDDetail}`,
                                                          },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "ps-4",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                -\n                                                " +
                                                                    _vm._s(
                                                                      _vm.showValue(
                                                                        detail.NMDetail
                                                                      )
                                                                    ) +
                                                                    "\n                                            "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                class: {
                                                                  "text-danger fw-bold":
                                                                    _vm.isCriticalLab(
                                                                      detail
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      _vm.showValue(
                                                                        detail.Hasil
                                                                      )
                                                                    ) +
                                                                    "\n                                            "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                "\n                                                " +
                                                                  _vm._s(
                                                                    _vm.showValue(
                                                                      detail.Satuan
                                                                    )
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                "\n                                                " +
                                                                  _vm._s(
                                                                    _vm.normalValue(
                                                                      detail
                                                                    )
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ]
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          _vm._v(" "),
                          !Object.keys(_vm.detailViewer.groups || {}).length
                            ? _c("EmptyState", {
                                attrs: {
                                  text: "Detail laboratorium tidak tersedia.",
                                },
                              })
                            : _vm._e(),
                        ]
                      : _vm.detailViewer.type === "radiologi"
                      ? [
                          _vm._l(_vm.detailViewer.rows, function (row, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "mb-4 pb-4 border-bottom",
                              },
                              [
                                _c("div", { staticClass: "row g-3 mb-3" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "text-muted small" },
                                      [
                                        _vm._v(
                                          "\n                                    Pemeriksaan\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "fw-semibold" }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.showValue(row.NmTarif)) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "text-muted small" },
                                      [
                                        _vm._v(
                                          "\n                                    Tanggal Hasil\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "fw-semibold" }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.formatDateTime(row.TglHasil)
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "text-muted small" },
                                      [
                                        _vm._v(
                                          "\n                                    Dokter Pembaca\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "fw-semibold" }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.showValue(row.DokterPembaca)
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "border rounded p-3 pre-wrap",
                                  domProps: {
                                    innerHTML: _vm._s(row.Hasil || "-"),
                                  },
                                }),
                                _vm._v(" "),
                                row.photo_url && row.photo_url.photo_url
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-sm btn-outline-primary mt-2",
                                        attrs: {
                                          href: row.photo_url.photo_url,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-eye me-1",
                                        }),
                                        _vm._v(
                                          "\n                            Lihat Citra\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          !_vm.detailViewer.rows.length
                            ? _c("EmptyState", {
                                attrs: {
                                  text: "Detail radiologi tidak tersedia.",
                                },
                              })
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h3", { staticClass: "mb-0" }, [_vm._v("Pengisian ICD Rawat Inap")]),
      _vm._v(" "),
      _c("small", { staticClass: "text-muted" }, [
        _vm._v(
          "\n                Riwayat pasien berdasarkan satu nomor registrasi\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "card-header bg-primary text-white fw-semibold" },
      [
        _c("i", { staticClass: "fa fa-user me-1" }),
        _vm._v("\n                Data Pasien\n            "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "card-header bg-primary text-white fw-semibold" },
      [
        _c("i", { staticClass: "fa fa-pencil-square-o me-1" }),
        _vm._v(
          "\n                        Pengisian ICD-10 dan ICD-9\n                    "
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-white fw-semibold" }, [
      _c("i", { staticClass: "fa fa-folder-open text-success me-1" }),
      _vm._v(
        "\n                        Riwayat Periode Rawat Inap\n                    "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", { staticStyle: { width: "140px" } }, [
          _vm._v(
            "\n                                                            Tanggal\n                                                        "
          ),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("SOAP")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "220px" } }, [
          _vm._v(
            "\n                                                            Instruksi\n                                                        "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "150px" } }, [
          _vm._v(
            "\n                                                            Petugas\n                                                        "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", { staticStyle: { width: "130px" } }, [
          _vm._v(
            "\n                                                            Tanggal\n                                                        "
          ),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("Nama Obat")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "80px" } }, [
          _vm._v(
            "\n                                                            Jumlah\n                                                        "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "140px" } }, [
          _vm._v(
            "\n                                                            Signa\n                                                        "
          ),
        ]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            "\n                                                            Aturan Pakai\n                                                        "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "150px" } }, [
          _vm._v(
            "\n                                                            Dokter\n                                                        "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", [_vm._v("Pemeriksaan")]),
        _vm._v(" "),
        _c("th", [_vm._v("Hasil")]),
        _vm._v(" "),
        _c("th", [_vm._v("Satuan")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nilai Normal")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }